import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import DropDownTable from '../../Shared/DropDownTable';
import '../../../css/MarketPlace/RespondentTransportationService.css';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import cancelicon from '../../../Assets/TruckVisits/Assets-Desktop/cancel-icon.svg';
import info_outline from '../../../Assets/UserAccess/Desktop/info-outline.svg';
import Input from '../../Shared/Input';
import UploadFile from '../../Shared/UploadFile';
import Button from '../../Shared/Button';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import uparrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import CancelModal from '../../Shared/CancelModalMarketPlace';
import SuccessModal from '../../Shared/SuccessModal';
import AlreadyBidModal from '../../Shared/GenericModalError';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_BIDQUOTE_ENDPOINT, SERVICE_REQUEST_ENDPOINT, SERVICE_CANCELLATION_POLICY_ENDPOINT } from '../../../Services/config/apiEndPoints';
// for redux
import { connect } from 'react-redux';
class RespondentTransportationService extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            serviceRequestID: 0,
            serviceRequestName: '',
            showWithoutCancelRequest: true,
            pickupLocation: 'Addington',
            destination: 'Bayhead',
            serviceWindowStartDateTime: "05-June-2021 09:30",
            serviceWindowEndDateTime: "20-June-2021 14:15",
            NoOfContainers: '5',
            commodity: 'Copper Cores and Concentrates',
            truckTypeRequirements: 'Flatbed Container',
            paymentTerms: 'Payment Transfer Within CC',
            RFQClosingDate: "10-June-2021 14:15",
            specialInstructions: "You have to pickup all the containers on service delivery start date.",
            quotePrice: "",
            comments: "",
            cancellationRefundPolicy: "Flexible",
            penaltyIdValue: "",
            penaltyDescriptionValue: '',
            loaderTime: false,
            PageDisable: false,
            filePathRespondentTSDocuments: '',
            hasOpenSuccess: false,
            hasOpen: false,
            errors: {},
            ApiServiceRequestData: [],
            cancellationRefundPolicydropdown: false,
            cancellationRefundPolicydata: [],
            hasOpenAlreadyBid: false
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        const { type, serviceRequestId, serviceName } = this.props.match.params;
        console.log('Hiiiii------', serviceRequestId, serviceName);
        this.setState({
            serviceRequestID: serviceRequestId,
            serviceRequestName: serviceName
        })
       
        if (type == "History") {
            this.setState({ showWithoutCancelRequest: false })
        } else if (type == "Request") {
            this.setState({ showWithoutCancelRequest: true })
            if (this.props.history.location.state?.cancellationPolicyFilter) {
                this.setState({
                    cancellationRefundPolicy: this.props.history.location.state?.cancellationPolicyFilter
                });
            }
        }
        //fetch service details
        this.getRequestDetails(serviceRequestId,type);
    
    }
    getCancellationPolicyData = () => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_CANCELLATION_POLICY_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    this.setState({
                        cancellationRefundPolicydata: apiData,
                    });
                    console.log('aaaaaaaaaaaaa', apiData, this.state.cancellationRefundPolicydata);
                    apiData?.every((md, index) => {
                        if (this.state.cancellationRefundPolicy == md?.basePenalty?.penaltyName) {
                            this.setState({
                                penaltyIdValue: md?.penaltyId,
                                penaltyDescriptionValue: md?.basePenalty?.penaltyDescription
                            })
                            return false
                        }
                        return true
                    })
                }
            }
        });
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ cancellationRefundPolicydropdown: false });
        }
    };
    toggleDropdowncancellationRefundPolicy = () => {
        this.setState({
            cancellationRefundPolicydropdown: !this.state.cancellationRefundPolicydropdown
        });
    };
    changeRoleTypecancellationRefundPolicy = (event) => {
        const found = this.state.cancellationRefundPolicydata.find((name) => {
            if (name.basePenalty.penaltyName === event.target.innerText) {
                return name
            }
        })
        this.setState({
            cancellationRefundPolicy: found.basePenalty.penaltyName,
            penaltyIdValue: found.penaltyId,
            penaltyDescriptionValue: found.basePenalty.penaltyDescription
        });
        this.setState({ cancellationRefundPolicydropdown: !this.state.cancellationRefundPolicydropdown });
    }
    getRequestDetails = (serviceRequestId,typeValue) => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_REQUEST_ENDPOINT + `?roleType=${this.props.manageProfileDataR?.selectedProfileType}&serviceRequestId=${serviceRequestId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("in 500");
                    this.setState({ hasOpenAlreadyBid: true });
                }
                else {
                    console.log('I am 200!');
                    if(typeValue == "History"){
                       
                      this.setState({cancellationRefundPolicy : data?.respondents?.otherRespondents[0]?.cancellationPolicy})  
                    }
                    this.setState({ ApiServiceRequestData: data },()=>{
                        this.getCancellationPolicyData();
                    });
                    console.log("ApiDataaaaaaaaa cancel", this.state.cancellationRefundPolicy);
                   
                }
            }
        });
    }
    handleSubmitQuotation = () => {
        //POST ​/services​/bidQuote Bid Quote for Generic Service
        if (this.handleQuotePriceValidation()) {
            ApiCall(
                'POST',
                serviceBaseURL + SERVICE_BIDQUOTE_ENDPOINT,
                {
                    "bidDocPath": this.state.filePathRespondentTSDocuments,
                    "comments": this.state.comments,
                    "cancellationPolicy": this.state.penaltyIdValue,
                    "quotePrice": parseInt(this.state.quotePrice),
                    "serviceName": 0,
                    "serviceRequestId": parseInt(this.state.serviceRequestID)
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == '500') {
                        console.log('I am 500!');
                    } else {
                        console.log('I am 200!');
                        this.setState({ hasOpenSuccess: true });
                    }
                }
                else {
                    console.log('Something went wrong!');
                }
            });
        }
    }
    handleContinue = () => {
       // this.props.history.push("/RespondentTSContainerDetails");
    }
    onCloseCancelModal = () => {
        this.setState({ hasOpen: false });
    };
    onCancelRequest = () => {
        this.setState({ hasOpen: true });
    };
    onCloseAlreadyBid = () => {
        this.setState({ hasOpenAlreadyBid: false });
        this.props.history.push('/ServiceRequest');
    };
    onYesModal = () => {
        ApiCall(
            'DELETE',
            serviceBaseURL + SERVICE_REQUEST_ENDPOINT + `?serviceRequestNumber=${this.state.serviceRequestID}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    this.setState({ hasOpen: false });
                    this.props.history.push(`/ServiceRequest`)
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    };
    handleChangeQuotePrice = (e) => {
        this.setState({ quotePrice: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                quotePrice: ''
            }
        });
        document.getElementsByName('quotePrice')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleQuotePriceValidation = () => {
        let errors = {};
        let formIsValid = true;
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        if (!this.state.quotePrice) {
            formIsValid = false;
            errors["quotePrice"] = Message.validation.required;
            document.getElementsByName('quotePrice')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(this.state.quotePrice)) {
            formIsValid = false;
            errors["quotePrice"] = Message.validation.num;
            document.getElementsByName('quotePrice')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('quotePrice')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleChangeComments = (e) => {
        this.setState({ comments: e.target.value });
    }
    uploadFileFunction = (uploadConfirm) => {
    }
    removeRespondentTSDocumentsLink = () => {
        let path = "";
        this.setState({ filePathRespondentTSDocuments: path });
    }
    setLoaderRespondentTSDocuments = (filePathURL) => {
        this.setState({ loaderTime: filePathURL });
        this.setState({ PageDisable: filePathURL });
    }
    setUploadLinkRespondentTSDocuments = (filePathURL) => {
        // for loader end
        this.setState({ filePathRespondentTSDocuments: filePathURL });
        this.setState({ loaderTime: false });
        this.setState({ PageDisable: false });
    }
    onCloseModal = () => {
        this.setState({ hasOpenSuccess: false });
        this.props.history.push('/');
    };
    render() {
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.RespondentTransportationServiceTitle} description={TitleDescription.RespondentTransportationServiceDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullRespondentTransportationService">
                    <div id="csnobox1RespondentTransportationService">
                        <nav class="RespondentTransportationServiceNavBar">
                            <div className="RespondentTransportationServiceNavBarHeading">
                                <small id="RespondentTransportationServiceNavBarHeadingValue"> Transportation Service</small>
                            </div>
                            {!this.state.showWithoutCancelRequest &&
                                <div id="RespondentTransportationServiceNAcceptMobile"
                                    className="RespondentTransportationServiceNNavbarNameRight"
                                    onClick={this.onCancelRequest}
                                >
                                    <img src={cancelicon} class=" mr-1 pb-1" id="RespondentTransportationServiceNavBarRightHeadingImg" alt="" loading="lazy" />
                                    <small id="RespondentTransportationServiceCancelRequest" >Cancel Request</small>
                                </div>
                            }
                        </nav>
                        <hr class="hr1" />
                        {!this.state.showWithoutCancelRequest &&
                            <>
                                <nav class="RespondentTransportationServiceNMobileNavbar">
                                    <div className="RespondentTransportationServiceNNavbarNameRight" onClick={this.onCancelRequest}>
                                        <img src={cancelicon} class=" mr-1 pb-1" id="RespondentTransportationServiceNavBarRightHeadingImg" alt="" loading="lazy" />
                                        <small id="RespondentTransportationServiceCancelRequest" >Cancel Request</small>
                                    </div>
                                </nav>
                                <hr class="hrCDMobile" />
                            </>
                        }
                        <div class={this.state.showWithoutCancelRequest ? "toppartRespondentTransportationServiceWOC" : "toppartRespondentTransportationService"}>
                            <div class="TopHeadingRespondentTS">Service Request Details</div>
                            <div class="TransportationServiceLessRCardcss">
                                <div class="TransportationServiceRInpSize">
                                    <small id="TransportationServiceRInpHeading">Pickup Location</small>
                                    <div class="TransportationServiceRLowerText">{this.state.ApiServiceRequestData?.serviceRequestData?.pickup_location}</div>
                                </div>
                                <div class="TransportationServiceRInpSize">
                                    <small id="TransportationServiceRInpHeading">Destination</small>
                                    <div class="TransportationServiceRLowerText">{this.state.ApiServiceRequestData?.serviceRequestData?.destination}</div>
                                </div>
                                <div class="TransportationServiceRInpSize">
                                    <small id="TransportationServiceRInpHeading">Service Window Start Date & Time</small>
                                    <div class="TransportationServiceRLowerText">{FormatTimeStamp(this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.startDateTime).timedateToLocale}</div>
                                </div>
                                <div class="TransportationServiceRInpSize">
                                    <small id="TransportationServiceRInpHeading">Service Window End Date & Time</small>
                                    <div class="TransportationServiceRLowerText">{FormatTimeStamp(this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.endDateTime).timedateToLocale}</div>
                                </div>
                                <div class="TransportationServiceRInpSize">
                                    <small id="TransportationServiceRInpHeading">No. of Containers</small>
                                    <div class="TransportationServiceRLowerText">{this.state.ApiServiceRequestData?.serviceRequestData?.container_size}</div>
                                </div>
                                <div class="TransportationServiceRInpSize">
                                    <small id="TransportationServiceRInpHeading">Commodity</small>
                                    <div class="TransportationServiceRLowerText">{this.state.ApiServiceRequestData?.serviceRequestData?.commodity}</div>
                                </div>
                                <div class="TransportationServiceRInpSize">
                                    <small id="TransportationServiceRInpHeading">Truck Type Requirements</small>
                                    <div class="TransportationServiceRLowerText">{this.state.ApiServiceRequestData?.serviceRequestData?.truck_type_req}</div>
                                </div>
                                <div class="TransportationServiceRInpSize">
                                    <small id="TransportationServiceRInpHeading">Payment Terms</small>
                                    <div class="TransportationServiceRLowerText">{this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.paymentTerm}</div>
                                </div>
                                <div class="TransportationServiceRInpSize">
                                    <small id="TransportationServiceRInpHeading">Request Closing Date</small>
                                    <div class="TransportationServiceRLowerText">{FormatTimeStamp(this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.rfqDateTime).timedateToLocale}</div>
                                </div>
                                <div class="TransportationServiceRInpSize">
                                    <small id="TransportationServiceRInpHeading">Special Instructions (Optional)</small>
                                    <div class="TransportationServiceRLowerText">{this.state.ApiServiceRequestData?.serviceRequestData?.special_instructions}</div>
                                </div>
                                <div class="TransportationServiceRInpSize">
                                    <small id="TransportationServiceRInpHeading">Update Reference Documents (Optional)</small>
                                    {(!this.state.ApiServiceRequestData?.serviceRequestData?.upload_documents) ?
                                        <div class="TransportationServiceNoDocU">No document uploaded</div> :
                                        <div class="TransportationServiceRUploaddocText">{this.state.ApiServiceRequestData?.serviceRequestData?.upload_documents.split('/')[11].split("'")[0]}</div>
                                    }
                                </div>
                            </div>
                            <div class="BottomHeadingRespondentTS">Your Response</div>
                            {this.state.showWithoutCancelRequest ?
                                <div>
                                    <div class="TransportationServiceLessRCardcss">
                                        <div class="RespondentTSRTextInpSize">
                                            <small id="UpdateServiceRInpHeading">Quote Price (Inclusive of Taxes)</small>
                                            <div className="pass-wrapper" id="UpdateServiceRInpDiv" >
                                                <Input
                                                    name="quotePrice"
                                                    class="input"
                                                    type="text" id="UpdateServiceRInpCss" value={this.state.quotePrice}
                                                    onChange={this.handleChangeQuotePrice}
                                                />
                                                <div className="QuotationDetailsDropError">{this.state.errors["quotePrice"]}</div>
                                            </div>
                                        </div>
                                        <div class="RespondentTSRTextInpSize">
                                            <small id="UpdateServiceRInpHeading">Comments (Optional)</small>
                                            <div className="pass-wrapper" id="UpdateServiceRInpDiv" >
                                                <Input
                                                    name="Comments" placeholder="Enter Your Comments"
                                                    class="input"
                                                    type="text" id="UpdateServiceRInpCss" value={this.state.comments}
                                                    onChange={this.handleChangeComments}
                                                />
                                            </div>
                                        </div>
                                        <div class="RespondentTSRInpSize">
                                            <small id="UpdateServiceRInpHeading">Upload Documents (Optional)</small>
                                            <div className="pass-wrapper" id="UpdateServiceRInpDiv" >
                                                <UploadFile uploaddivid="uploadRespondentTSDocuments" idupload="upload"
                                                    name="fileupload"
                                                    fileType="jpeg, jpg, png, pdf"
                                                    setUploadConfirm={this.uploadFileFunction}
                                                    removeLink={this.removeRespondentTSDocumentsLink}
                                                    upload_link="cipcUpload" uploadicon="cipcIcon"
                                                    setFileLink={this.setUploadLinkRespondentTSDocuments}
                                                    setLoader={this.setLoaderRespondentTSDocuments}
                                                    staticFileName={'Response_Documents.'}
                                                />
                                            </div>
                                        </div>
                                        <div class="TransportationServiceRInpSize">
                                            <small class="TransportationServiceResptooltip2" id="TransportationServiceRespInpHeading">
                                                <div class="TransportationServiceResptooltipouter">
                                                    <span class="TransportationServiceResptooltiptext">
                                                        <div class="TransportationServiceResptooli01">
                                                            <div class="TransportationServiceRespTooltipLowerText">{this.state.cancellationRefundPolicy}</div>
                                                            <small id="TransportationServiceRespTooltipdataHeading">{this.state.penaltyDescriptionValue}</small>
                                                        </div>
                                                    </span>
                                                </div>
                                        Cancellation & Refund Policy
                                        <img id="TransportationServiceRespInfo_img" src={info_outline} />
                                            </small>
                                            <div className="pass-wrapper" id="UpdateServiceRInpDiv" >
                                                <Input
                                                    readOnly name="cancellationRefundPolicy" class="input" placeholder="Select"
                                                    type="text" id={this.state.cancellationRefundPolicydropdown ? "TransportServiceBtmBorderLessCss" : "TransportServiceInpDropCss"} value={this.state.cancellationRefundPolicy}
                                                />
                                                <i id="TransportServiceInp_imgDrop" onClick={this.toggleDropdowncancellationRefundPolicy}>
                                                    {this.state.cancellationRefundPolicydropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                                </i>
                                            </div>
                                            {this.state.cancellationRefundPolicydropdown && (
                                                <div class="TransportServiceDropDowmDiv" >
                                                    <div class="TransportServiceDropCard" ref={this.container} >
                                                        {(this.state.cancellationRefundPolicydata.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(val) => this.changeRoleTypecancellationRefundPolicy(val)} id="TransportServiceDropRowSize">
                                                                    <small class="" id="TransportServiceDropRowText" >{name.basePenalty.penaltyName} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="TransportServiceRBtnDiv">
                                        <Button class="TransportServiceRBtnCss" onClick={this.handleSubmitQuotation}>
                                            <small class="TransportServiceRBtntext">Submit Response</small>
                                        </Button>
                                    </div>
                                </div>
                                :
                                <div>
                                    <div class="TransportationServiceLessRCardcss">
                                        <div class="TransportationServiceRInpSize">
                                            <small id="TransportationServiceRInpHeading">Quote Price (Inclusive of Taxes)</small>
                                            <div class="TransportationServiceRLowerText">{this.state.ApiServiceRequestData?.respondents?.otherRespondents[0]?.quotationAmount}</div>
                                        </div>
                                        <div class="TransportationServiceRInpSize">
                                            <small id="TransportationServiceRInpHeading">Comments (Optional)</small>
                                            {(!this.state.ApiServiceRequestData?.respondents?.otherRespondents[0]?.comments) ?
                                                <div class="RespondentTSComments">No Comments </div>
                                                :
                                                <div class="TransportationServiceRLowerText">{this.state.ApiServiceRequestData?.respondents?.otherRespondents[0]?.comments}</div>
                                            }
                                        </div>
                                        <div class="TransportationServiceRInpSize">
                                            <small id="TransportationServiceRInpHeading">Update Reference Documents (Optional)</small>
                                            {(!this.state.ApiServiceRequestData?.respondents?.otherRespondents[0]?.docPath) ?
                                                <div class="TransportationServiceNoDocU">No document uploaded</div> :
                                                <div class="TransportationServiceRUploaddocText">{this.state.ApiServiceRequestData?.respondents?.otherRespondents[0]?.docPath?.split('/')[11]?.split("'")[0]}</div>
                                            }
                                        </div>
                                        <div class="TransportationServiceRInpSize">
                                            <small class="TransportationServiceResptooltip2" id="TransportationServiceRespInpHeading">
                                                <div class="TransportationServiceResptooltipouter">
                                                    <span class="TransportationServiceResptooltiptext">
                                                        <div class="TransportationServiceResptooli01">
                                                            <div class="TransportationServiceRespTooltipLowerText">{this.state.cancellationRefundPolicy}</div>
                                                            <small id="TransportationServiceRespTooltipdataHeading">{this.state.penaltyDescriptionValue}</small>
                                                        </div>
                                                    </span>
                                                </div>
                                        Cancellation & Refund Policy
                                        <img id="TransportationServiceRespInfo_img" src={info_outline} />
                                            </small>
                                            <div class="TransportationServiceRLowerText">{this.state.cancellationRefundPolicy}</div>
                                        </div>
                                    </div>
                                    <div class="TransportServiceRBtnDiv">
                                        <Button class="TransportServiceRBtnCss" onClick={this.handleContinue}>
                                            <small class="TransportServiceRBtntext">Continue</small>
                                        </Button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="cs2footer11RespondentTransportationService">
                    <Footer />
                </div>
                <div class="cs2footer22RespondentTransportationService">
                    <Footer2 />
                </div>
                <CancelModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseCancelModal} onYesModal={this.onYesModal}>
                    <div>
                        <div class="cancelRespondentTransportationServiceDiv">
                            <small class="RespondenttransportationServiceText">{Message.marketPlace.cancelModalQuery}</small>
                            <small class="RespondenttransportationServiceTextSmall" id='RespondenttransportationDesk'>If you have already made the payment the refund</small>
                            <small class="RespondenttransportationServiceTextSmall" id='RespondenttransportationDesk'> will be initiated based on the cancellation policy.</small>
                            <small class="RespondenttransportationServiceTextSmall" id='RespondenttransportationMobile'>{Message.marketPlace.cancelModalNote}</small>
                        </div>
                    </div>
                </CancelModal>
                <SuccessModal hasOpen={this.state.hasOpenSuccess} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successRatingdivout">
                            <small class="successRatingdivsm">Your response has been submitted
 </small>
                            <small class="successRatingdivsm"> successfully.</small>
                        </div>
                    </div>
                </SuccessModal>
                <AlreadyBidModal hasOpen={this.state.hasOpenAlreadyBid} onCloseModal={this.onCloseAlreadyBid} >
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="addprofilemodalsmall">{Message.marketPlace.AlreadyBidModalNote}</small>
                        </div>
                    </div>
                </AlreadyBidModal>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        manageProfileDataR: state.manageProfileReducer.data
    }
}
export default connect(mapStateToProps)(RespondentTransportationService);